import { register, find } from '../../../Javascript/Utils.js'
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin'

// https://github.com/dimsemenov/photoswipe-dynamic-caption-plugin

const ImageGallery = el => {
  const thisGallery = find('.photoswipe', el)
  const lightbox = new PhotoSwipeLightbox({
    gallery: thisGallery,
    children: 'a',
    pswpModule: () => import('photoswipe'),
    bgOpacity: 0.9,
    paddingFn: (viewportSize) => {
      return {
        top: 30, bottom: 30, left: 70, right: 70
      }
    },
    closeTitle: 'Schließen',
    zoomTitle: 'Vergrößern',
    arrowPrevTitle: 'Voriges Bild',
    arrowNextTitle: 'Nächstes Bild',
    errorMsg: '🔴 Das Bild konnte nicht geladen werden',
    indexIndicatorSep: ' / '
  })

  function makeCaption () {
    return new PhotoSwipeDynamicCaption(lightbox, {
      type: 'aside',
      mobileLayoutBreakpoint: 920
    })
  }
  makeCaption()

  lightbox.init()
}

register('ImageGallery', ImageGallery)
